import React, { Fragment, useCallback, useEffect, useState } from "react";
import { listTerms } from "services/term";
import DOMPurify from "dompurify";
import Loading from "components/Loading";
import { ReactComponent as Close } from "icons/close-circle-gray.svg";
import { ToastContainer } from "react-toastify";

type Props = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalTerms: React.FC<Props> = ({ show, setShow }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [term, setTerm] = useState<any>();

  const list = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await listTerms();
      setTerm(data);
    } catch (_) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    list();
  }, [list]);

  const createMarkup = (html: any) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };

  return (
    <Fragment>
      <Loading loading={loading} />
      {show && (
        <div className="fixed z-30 inset-0 bg-bt-dark-gray-transparent bg-opacity-50 w-full h-full">
          <div className="flex flex-row h-full">
            <div className="my-auto">
              <div className="bg-bt-white p-6 w-1/2 mx-auto rounded-md">
                <div className="flex flex-row justify-end mb-4">
                  <Close
                    width={22}
                    height={22}
                    className="cursor-pointer"
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                </div>
                <div className="h-56 scroll-m-0 overflow-auto">
                  {term && (
                    <div dangerouslySetInnerHTML={createMarkup(term.content)} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </Fragment>
  );
};

export default ModalTerms;
